import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import * as React from 'react';
import {
  GREEN_COLOR,
  ORANGE_COLOR,
  RED_COLOR,
} from '../../../../../constants/ColorsConst';

const PieChartNotasEvlauativas = ({ estudiantes, actividadesArray }) => {
  const [data, setData] = React.useState([0, 0, 0]);

  React.useEffect(() => {
    let res = [0, 0, 0];

    estudiantes.forEach((est) => {
      const total = est.notasEvaluativas.reduce(
        (total, { ptevaInstrumento, nota }) => {
          const actividad = actividadesArray.find(
            (act) => act.id === ptevaInstrumento.id,
          );
          return actividad ? total + parseInt(nota ?? '0') : total;
        },
        0,
      );

      const def = Math.round(total / actividadesArray.length);
      if (def <= 9) res[0]++;
      if (def > 9 && def <= 15) res[1]++;
      if (def > 15) res[2]++;
    });

    setData(res);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estudiantes]);

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={{
        chart: {
          type: 'pie',
        },
        title: {
          text: 'Rendimiento del momento',
        },
        plotOptions: {
          pie: {
            dataLabels: {
              enabled: true,
              format:
                '<b>{point.name}</b>: <br />{y} Estudiantes - {point.percentage:.0f}%',
            },
          },
        },
        series: [
          {
            name: 'Total',
            data: [
              {
                name: 'REPROBADOS',
                y: data[0],
                color: RED_COLOR,
              },
              {
                name: 'REGULARES',
                y: data[1],
                color: ORANGE_COLOR,
              },
              {
                name: 'EXIMIDOS',
                y: data[2],
                color: GREEN_COLOR,
              },
            ],
          },
        ],
      }}
    />
  );
};

export default PieChartNotasEvlauativas;
